import { PostCancelRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/post_cancel/$')({
  component: PostCancelRoute,
});
